import { useEffect } from 'react';
import {
  W3W_MARKER_LAYER,
  ALERT_MARKER_CIRCLES_LAYER,
  ALERT_MARKERS_LAYER,
  AA_ALERT_MARKER_CIRCLES_LAYER,
  AA_ALERT_MARKERS_LAYER,
  TRAIN_ALERT_MARKER_CIRCLES_LAYER,
  TRAIN_ALERT_MARKERS_LAYER,
  TEST_ALERT_MARKER_CIRCLES_LAYER,
  TEST_ALERT_MARKERS_LAYER,
  CALL_MARKERS_POLYLINE_LAYER,
  CALL_MARKER_CIRCLES_LAYER,
  CALL_MARKERS_LAYER,
} from '../constants/esriMapLayerIds';

// List of map marker layer id's, displayed in the order from top to bottom.
const mapMarkerLayerIds = [
  CALL_MARKERS_LAYER,
  CALL_MARKER_CIRCLES_LAYER,
  CALL_MARKERS_POLYLINE_LAYER,
  TEST_ALERT_MARKERS_LAYER,
  TEST_ALERT_MARKER_CIRCLES_LAYER,
  TRAIN_ALERT_MARKERS_LAYER,
  TRAIN_ALERT_MARKER_CIRCLES_LAYER,
  AA_ALERT_MARKERS_LAYER,
  AA_ALERT_MARKER_CIRCLES_LAYER,
  ALERT_MARKERS_LAYER,
  ALERT_MARKER_CIRCLES_LAYER,
  W3W_MARKER_LAYER,
];

/**
 * Reorder the Esri map marker layers when the length of the Esri map layers array changes so that
 * map markers are always on top of other layers, such as GIS, spatial layers, etc.
 * @param {Object} map - The Esri map oject.
 */
const useReorderEsriMapMarkers = map => {
  const numEsriMapLayers = map?.mapInstance?.map?.layers?.length;

  useEffect(() => {
    if (map?.mapInstance && numEsriMapLayers) {
      mapMarkerLayerIds.forEach((id, index) => {
        const layer = map.mapInstance.map.findLayerById(id);

        const layerIndex = numEsriMapLayers - 1 - index;

        if (layer) {
          // ArcGIS method to reorder map layers.
          // https://developers.arcgis.com/javascript/latest/api-reference/esri-Map.html#reorder
          map.mapInstance.map.reorder(layer, layerIndex);
        }
      });
    }
  }, [map?.mapInstance, numEsriMapLayers]);
};

export default useReorderEsriMapMarkers;
